export default __webpack_public_path__ + "static/app-re-3d1ab770d6861658230fbb2573289ef5.png";